import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'nova-infinite-scroll-container',
    templateUrl: './infinite-scroll-container.component.html',
    styleUrls: ['./infinite-scroll-container.component.scss']
})
export class InfiniteScrollContainerComponent {
    // Input properties to customize the behavior of the component
    @Input() width = 400;
    @Input() height = 300;
    @Input() maxHeight = 300;
    @Input() offset = 100;

    // Output event emitter for notifying parent components when scrolling reaches bottom
    @Output() scrolled = new EventEmitter<void>();

    // Event handler for the scroll event
    onScroll(event: Event) {
        const element = event.target as HTMLElement;
        const scrollPosition = element.scrollHeight - element.scrollTop;
        const containerHeight = element.clientHeight;

        // check if scroller position is close to the bottom of the container
        if (scrollPosition < containerHeight + this.offset) {
            // emit the 'scrolled' event to notify the parent component
            this.scrolled.emit();
        }
    }
}
